module.exports = __webpack_public_path__ + "static/panorama-a1eb41ee63a4437c425a2ace8f8716d1.svg";